const CalendarPublishIssueBadge = ({ issue, title }) => {
  const fill = issue === "partial" ? "#f59e0b" : "#ef4444";

  return (
    <span
      className={`calendar-event-issue-badge calendar-event-issue-badge--${issue}`}
      title={title}
      aria-label={title}
      role="img"
    >
      <svg
        width={11}
        height={11}
        viewBox="0 0 22 22"
        aria-hidden
        focusable="false"
      >
        <circle cx={11} cy={11} r={11} fill={fill} />
        <text
          x={11}
          y={11}
          textAnchor="middle"
          dominantBaseline="central"
          fill="#ffffff"
          fontSize={12}
          fontWeight={700}
          fontFamily={
            'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif'
          }
        >
          !
        </text>
      </svg>
    </span>
  );
};

export const CalendarEventComponent = ({ event }) => {
  const start = new Date(event.start);
  const hours = String(start.getHours()).padStart(2, "0");
  const minutes = String(start.getMinutes()).padStart(2, "0");
  const timeLabel = `${hours}:${minutes}`;

  const hasPublishIssue =
    event.publishIssue === "failure" || event.publishIssue === "partial";

  return (
    <div data-event-id={event.id} className="calendar-event-component">
      <div className="calendar-event-title-line">
        {hasPublishIssue && (
          <CalendarPublishIssueBadge
            issue={event.publishIssue}
            title={event.statusLabel}
          />
        )}
        <span className="calendar-event-title">{event.title}</span>
        <span className="calendar-event-time">{timeLabel}</span>
      </div>
      <span className="calendar-event-meta">
        {event.sourceLabel ? `${event.sourceLabel} · ` : ""}
        {event.statusLabel}
      </span>
    </div>
  );
};
